// import React, { useState, useEffect, useRef } from "react";
// import { useNavigate } from "react-router-dom";
// import config from "../../Common/Configurations/APIConfig";
// import apiService from "../../Common/Configurations/APIService";
// import Header from "../../Common/Layout/Header";
// import { useAuth } from "../../Common/Configurations/AuthContext";
// import Login from "../../Authentication/Login";
// import moment from "moment";
// import Flatpickr from "react-flatpickr";
// import Select from "react-select";
// import DestinationModal from "../Package/DestinationModal";
// import TravelTypeModal from "../Package/TravelTypeModal";
// import PackageDateModal from "../Package/PackageDateModal";
// import FromOriginModal from "../Package/FromOriginModal";
// import currencies from "../../Data/Currency.json";
// import ImageUploadModal from "../Package/ImageUploadModal";
// import ImageViewModal from "../Package/ImageViewModal";

// // Default image path
// const DEFAULT_IMAGE = "/assets/images/default-package.jpg";

// // initialFieldValues now hardcodes the type to 'Hajj'
// const initialFieldValues = {
//   packageId: "00000000-0000-0000-0000-000000000000",
//   destinationId: "00000000-0000-0000-0000-000000000000",
//   travelTypeId: "00000000-0000-0000-0000-000000000000",
//   companyId: "00000000-0000-0000-0000-000000000000",
//   userId: "00000000-0000-0000-0000-000000000000",
//   fromOriginId: "00000000-0000-0000-0000-000000000000",
//   packageDateId: "00000000-0000-0000-0000-000000000000",
//   imageName: "",
//   imageFile: null,
//   imageSrc: DEFAULT_IMAGE,
//   packageName: "",
//   noOfPersons: "",
//   startedDate: moment().format("DD-MMM-YYYY"),
//   duration: "",
//   includes: "",
//   description: "",
//   destinationsCover: "",
//   price: "",
//   status: "",
//   type: "Hajj",
//   contactName: "",
//   contactPhoneNumber: "",
//   contactEmail: "",
//   currency: "",
// };

// const HajjPackageForm = ({
//   packageId,
//   isEditMode,
//   setIsEditMode,
//   onPackageCreated,
//   packageDetails
// }) => {
//   const { user, loading } = useAuth();
//   const navigate = useNavigate();
//   const [btnLoading, setBtnLoading] = useState(false);
//   const [values, setValues] = useState(initialFieldValues);
//   const [errors, setErrors] = useState({});
//   const [recordForEdit, setRecordForEdit] = useState(null);
//   const [pageSize] = useState(20);
//   const [pageNumber] = useState(1);
//   const [destination, setDestination] = useState([]);
//   const [travelType, setTravelType] = useState([]);
//   const [origin, setOrigin] = useState([]);
//   const [packageDate, setPackageDate] = useState([]);
//   const [imagePreview, setImagePreview] = useState(DEFAULT_IMAGE);
//   const [showImageUploadModal, setShowImageUploadModal] = useState(false);
//   const [showImageViewModal, setShowImageViewModal] = useState(false);
//   const flatpickrRef = useRef(null);
//   const [showDestinationModal, setShowDestinationModal] = useState(false);
//   const [showTravelTypeModal, setShowTravelTypeModal] = useState(false);
//   const [packageDates, setPackageDates] = useState([]);
//   const [showPackageDateModal, setShowPackageDateModal] = useState(false);
//   const [showFromOriginModal, setShowFromOriginModal] = useState(false);

//   useEffect(() => {
//      if (packageDetails) { 
//      setValues({
//              ...initialFieldValues, // Start fresh to avoid merging old state
//              ...packageDetails,
//              startedDate: moment(packageDetails.startedDate).format("DD-MMM-YYYY"),
//            });
//       setImagePreview(packageDetails.imageSrc || DEFAULT_IMAGE);
//       setIsEditMode(true);
//     } else if (user && !loading && !packageId) {
//       setValues((prev) => ({
//        ...initialFieldValues,
//         contactName: user.name || "",
//         contactPhoneNumber: user.phoneNumber || "",
//         contactEmail: user.email || "",
//         currency: user.currency || "",
//         imageSrc: DEFAULT_IMAGE,
//       }));
//     }
//   }, [packageDetails, user, loading, packageId, setIsEditMode]);

//   const GetDestination = async (packageType) => {
//     try {
//       const url = `${config.GETDESTIONBYTYPE}/${user.cid}?type=${packageType}`;
//       const res = await apiService.getAll(url);
//       const destinations = res;
//       setDestination(destinations);
//     } catch (error) {
//       console.error("Error fetching destinations:", error);
//       setDestination([]);
//     }
//   };

//   const GetTravelType = async () => {
//     try {
//       const res = await apiService.get(`${config.GETALLTRAVELTYPES}`);
//       const travelTypes = res;
//       setTravelType(travelTypes);
//     } catch (error) {
//       console.error("Error fetching travel types:", error);
//       setTravelType([]);
//     }
//   };

//   const GetPackageDates = async (packageType) => {
//     try {
//       const url = `${config.GETDATESBYTYPE}/${user.cid}?type=${packageType}`;
//       const res = await apiService.getAll(url);
//       setPackageDates(res);
//     } catch (error) {
//       console.error("Error fetching package dates:", error);
//       setPackageDates([]);
//     }
//   };

//   const GetOrigins = async () => {
//     try {
//       const res = await apiService.get(
//         `${config.GETALLORIGINBYCOMPANYID}/${user?.cid}`
//       );
//       const origin = res;
//       setOrigin(origin);
//     } catch (error) {
//       console.error("Error fetching origins:", error);
//       setOrigin([]);
//     }
//   };

//   const handlePackageDateCreated = () => {
//     GetPackageDates("Hajj");
//   };

//   useEffect(() => {
//     GetDestination("Hajj");
//     GetTravelType(pageNumber);
//     GetOrigins();
//     GetPackageDates("Hajj");
//   }, []);

//   const validate = () => {
//     let temp = {};
//     temp.destinationId =
//       values.destinationId !== "00000000-0000-0000-0000-000000000000";
//     temp.fromOriginId =
//       values.fromOriginId !== "00000000-0000-0000-0000-000000000000";
//     temp.packageName = values.packageName !== "";
//     temp.duration = values.duration !== "";
//     temp.startedDate = values.startedDate !== "";
//     temp.destinationsCover = values.destinationsCover !== "";
//     temp.noOfPersons = values.noOfPersons !== "";
//     temp.includes = values.includes !== "";
//     temp.price = values.price !== "" && !isNaN(values.price);
//     temp.status = values.status !== "";
//     temp.description = values.description !== "";
//     temp.imageFile = isEditMode ? true : values.imageSrc !== "";
//     setErrors(temp);
//     return Object.values(temp).every((x) => x === true);
//   };

//   const handleImageUpload = (file, imageSrc) => {
//     setImagePreview(imageSrc);
//     setValues({
//       ...values,
//       imageFile: file,
//       imageSrc: imageSrc,
//       imageName: file ? file.name : "default-package.jpg",
//     });
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (validate()) {
//       setBtnLoading(true);
//       const formData = new FormData();
//       Object.entries({
//         ...values,
//         companyId: user?.cid,
//         userId: user?.id,
//         fromOriginId: values.fromOriginId,
//         packageDateId: values.packageDateId,
//       }).forEach(([key, value]) => {
//         formData.append(key, value ?? "");
//       });

//       if (values.imageFile) {
//         formData.append("imageFile", values.imageFile);
//       }

//       try {
//         const isNew =
//           values.packageId === "00000000-0000-0000-0000-000000000000";
//         if (isNew) {
//           const response = await apiService.create(
//             config.CREATEPACKAGE,
//             formData
//           );
//           const newPackageId = response.packageId;
//           navigate(`/hajjpackage/${newPackageId}`);
//         } else {
//           await apiService.update(config.UPDATEPACKAGE, formData);
//           const updatedResponse = await apiService.getById(
//             config.GETPACKAGEBYID,
//             values.packageId
//           );
//           setRecordForEdit(updatedResponse.data || updatedResponse);
//           navigate(`/hajjpackage/${values.packageId}`);
//         }
//         onPackageCreated?.();
//       } catch (error) {
//         console.error("Error submitting form:", error);
//       } finally {
//         setBtnLoading(false);
//       }
//     }
//   };

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setValues({
//       ...values,
//       [name]: value,
//     });
//   };

//   const handleDestinationCreated = () => {
//     GetDestination("Hajj");
//   };

//   const handleTravelTypeCreated = (newTravelType) => {
//     setTravelType((prevTravelTypes) => {
//       if (
//         prevTravelTypes.some(
//           (travel) => travel.travelTypeId === newTravelType.travelTypeId
//         )
//       ) {
//         return prevTravelTypes;
//       }
//       return [...prevTravelTypes, newTravelType];
//     });

//     setValues({
//       ...values,
//       travelTypeId: newTravelType.travelTypeId,
//     });
//     GetTravelType(pageNumber);
//   };

//   const handleOriginCreated = () => {
//     GetOrigins();
//   };

//   const resetForm = () => {
//     setValues(initialFieldValues);
//     setImagePreview(DEFAULT_IMAGE);
//     setBtnLoading(false);
//     setErrors({});
//   };

//   const applyErrorClass = (field) =>
//     field in errors && errors[field] === false ? " form-control-danger" : "";

//   return (
//     <div id="layout-wrapper">
//       <DestinationModal
//         show={showDestinationModal}
//         onHide={() => setShowDestinationModal(false)}
//         onDestinationCreated={handleDestinationCreated}
//         type="Hajj"
//       />
//       <TravelTypeModal
//         show={showTravelTypeModal}
//         onHide={() => setShowTravelTypeModal(false)}
//         onTravelTypeCreated={handleTravelTypeCreated}
//       />
//       <PackageDateModal
//         show={showPackageDateModal}
//         onHide={() => setShowPackageDateModal(false)}
//         onPackageDateCreated={handlePackageDateCreated}
//         type="Hajj"
//       />
//       <FromOriginModal
//         show={showFromOriginModal}
//         onHide={() => setShowFromOriginModal(false)}
//         onOriginCreated={handleOriginCreated}
//       />

//       {/* Reusable Image Modals */}
//       <ImageUploadModal
//         show={showImageUploadModal}
//         onHide={() => setShowImageUploadModal(false)}
//         onImageUpload={handleImageUpload}
//         title="Upload Package Image"
//         defaultImage={DEFAULT_IMAGE}
//         aspectRatio="4/3"
//       />

//       <ImageViewModal
//         show={showImageViewModal}
//         onHide={() => setShowImageViewModal(false)}
//         imageSrc={imagePreview}
//         title="Package Image"
//         defaultImage={DEFAULT_IMAGE}
//         aspectRatio="4/3"
//       />

//       <div className="main-content">
//         <div className="container-fluid">
//           <div className="card">
//             <div className="card-header">
//               <h4>{isEditMode ? "Edit Hajj Package" : "Add Hajj Package"}</h4>
//             </div>
//             <div className="card-body">
//               <form onSubmit={handleSubmit} autoComplete="off" noValidate>
//                 {/* Image Upload/View Buttons - Moved to top like Package form */}
//                 <div className="row mb-4">
//                   <div className="col-lg-12">
//                     <div className="d-flex gap-2 mb-3">
//                       <button
//                         type="button"
//                         className="btn btn-info"
//                         onClick={() => setShowImageUploadModal(true)}
//                       >
//                         <i className="ri-upload-line me-1"></i> Upload Image
//                       </button>
//                       <button
//                         type="button"
//                         className="btn btn-outline-info"
//                         onClick={() => setShowImageViewModal(true)}
//                       >
//                         <i className="ri-eye-line me-1"></i> View Image
//                       </button>
//                     </div>
//                     {errors.imageFile === false && !isEditMode && (
//                       <div className="validationerror">Please Upload image</div>
//                     )}
//                   </div>
//                 </div>

//                 <div className="row">
//                   <div className="col-lg-4">
//                     <div className="mb-3">
//                       <label htmlFor="fromOrigin" className="form-label">
//                         Origin
//                       </label>
//                       <div className="input-group">
//                         <select
//                           value={values.fromOriginId}
//                           name="fromOriginId"
//                           onChange={handleInputChange}
//                           className={
//                             "form-select" + applyErrorClass("fromOriginId")
//                           }
//                         >
//                           <option value="00000000-0000-0000-0000-000000000000">
//                             Please select
//                           </option>
//                           {origin.length > 0 &&
//                             origin.map((o) => (
//                               <option
//                                 key={o.fromOriginId}
//                                 value={o.fromOriginId}
//                               >
//                                 {o.fromOriginName}
//                               </option>
//                             ))}
//                         </select>
//                         <button
//                           type="button"
//                           className="btn btn-primary"
//                           onClick={() => setShowFromOriginModal(true)}
//                         >
//                           +
//                         </button>
//                       </div>
//                       {errors.fromOriginId === false && (
//                         <div className="validationerror">Please select</div>
//                       )}
//                     </div>
//                   </div>
//                   <div className="col-lg-4">
//                     <div className="mb-3">
//                       <label htmlFor="destination" className="form-label">
//                         Destination
//                       </label>
//                       <div className="input-group">
//                         <select
//                           value={values.destinationId}
//                           name="destinationId"
//                           onChange={handleInputChange}
//                           className={
//                             "form-select" + applyErrorClass("destinationId")
//                           }
//                         >
//                           <option value="00000000-0000-0000-0000-000000000000">
//                             Please select
//                           </option>
//                           {destination.length > 0 &&
//                             destination.map((dt) => (
//                               <option
//                                 key={dt.destinationId}
//                                 value={dt.destinationId}
//                               >
//                                 {dt.destinationName}
//                               </option>
//                             ))}
//                         </select>
//                         <button
//                           type="button"
//                           className="btn btn-primary"
//                           onClick={() => setShowDestinationModal(true)}
//                         >
//                           +
//                         </button>
//                       </div>
//                       {errors.destinationId === false && (
//                         <div className="validationerror">Please select</div>
//                       )}
//                     </div>
//                   </div>
//                   <div className="col-lg-4">
//                     <div className="mb-3">
//                       <label htmlFor="travelType" className="form-label">
//                         Travel Type
//                       </label>
//                       <div className="input-group">
//                         <select
//                           value={values.travelTypeId}
//                           name="travelTypeId"
//                           onChange={handleInputChange}
//                           className={
//                             "form-select" + applyErrorClass("travelTypeId")
//                           }
//                         >
//                           <option value="00000000-0000-0000-0000-000000000000">
//                             Please select
//                           </option>
//                           {travelType.length > 0 &&
//                             travelType.map((ht) => (
//                               <option
//                                 key={ht.travelTypeId}
//                                 value={ht.travelTypeId}
//                               >
//                                 {ht.travelTypeName}
//                               </option>
//                             ))}
//                         </select>
//                         <button
//                           type="button"
//                           className="btn btn-primary"
//                           onClick={() => setShowTravelTypeModal(true)}
//                         >
//                           +
//                         </button>
//                       </div>
//                       {errors.destinationId === false && (
//                         <div className="validationerror">Please select</div>
//                       )}
//                     </div>
//                   </div>

//                   <div className="col-lg-8 mb-3">
//                     <label className="form-label">Package Name</label>
//                     <input
//                       type="text"
//                       name="packageName"
//                       value={values.packageName}
//                       onChange={handleInputChange}
//                       className={
//                         "form-control " + applyErrorClass("packageName")
//                       }
//                       placeholder="Hajj Package"
//                     />
//                     {errors.packageName === false && (
//                       <div className="validationerror">
//                         Please enter package
//                       </div>
//                     )}
//                   </div>

//                   <div className="col-lg-4">
//                     <div className="mb-3">
//                       <label className="form-label">Duration</label>
//                       <select
//                         name="duration"
//                         value={values.duration}
//                         onChange={handleInputChange}
//                         className={"form-select " + applyErrorClass("duration")}
//                       >
//                         <option value="">Select Duration</option>
//                         {Array.from({ length: 20 }, (_, i) => {
//                           const nights = i + 1;
//                           const days = nights + 1;
//                           return (
//                             <option
//                               key={nights}
//                               value={`${nights} Nights  ${days} Days`}
//                             >
//                               {nights} Night{nights > 1 ? "s" : ""} {days} Day
//                               {days > 1 ? "s" : ""}
//                             </option>
//                           );
//                         })}
//                       </select>
//                       {errors.duration === false && (
//                         <div className="validationerror">Please select</div>
//                       )}
//                     </div>
//                   </div>

//                   <div className="col-lg-4">
//                     <div className="mb-3">
//                       <label htmlFor="starteddate" className="form-label">
//                         Travel Date
//                       </label>
//                       <div className="input-group">
//                         <Flatpickr
//                           className={
//                             "form-control d-block" +
//                             applyErrorClass("startedDate")
//                           }
//                           name="startedDate"
//                           options={{
//                             dateFormat: "d-M-Y",
//                             clickOpens: false,
//                           }}
//                           value={values.startedDate}
//                           placeholder="Please Select Date"
//                           onChange={(date) => {
//                             const formattedDate = moment(date[0]).format(
//                               "DD-MMM-YYYY"
//                             );
//                             handleInputChange({
//                               target: {
//                                 name: "startedDate",
//                                 value: formattedDate,
//                               },
//                             });
//                           }}
//                           ref={flatpickrRef}
//                           readOnly
//                         />
//                         <div
//                           className="input-group-text bg-primary border-primary text-white"
//                           style={{ cursor: "pointer" }}
//                           onClick={() => flatpickrRef.current.flatpickr.open()}
//                         >
//                           <i className="ri-calendar-2-line" />
//                         </div>
//                       </div>

//                       {errors.startedDate === false ? (
//                         <div className="validationerror">Please select</div>
//                       ) : (
//                         ""
//                       )}
//                     </div>
//                   </div>
//                   <div className="col-lg-4">
//                     <div className="mb-3">
//                       <label className="form-label">Destinations Cover</label>
//                       <input
//                         type="text"
//                         name="destinationsCover"
//                         value={values.destinationsCover}
//                         onChange={handleInputChange}
//                         className={
//                           "form-control " + applyErrorClass("destinationsCover")
//                         }
//                         placeholder="Makkah, Madinah"
//                         onKeyDown={(e) => {
//                           if (e.key === "Enter") {
//                             e.preventDefault();
//                           }
//                         }}
//                       />
//                       {errors.destinationsCover === false && (
//                         <div className="validationerror">
//                           Please enter destinationsCover
//                         </div>
//                       )}
//                     </div>
//                   </div>
//                   <div className="col-lg-4">
//                     <div className="mb-3">
//                       <label className="form-label">No of Persons</label>
//                       <input
//                         type="text"
//                         name="noOfPersons"
//                         value={values.noOfPersons}
//                         onChange={handleInputChange}
//                         className={
//                           "form-control " + applyErrorClass("noOfPersons")
//                         }
//                         placeholder="5"
//                       />
//                       {errors.noOfPersons === false && (
//                         <div className="validationerror">
//                           Please enter noofpersons
//                         </div>
//                       )}
//                     </div>
//                   </div>

//                   <div className="col-lg-4">
//                     <div className="mb-3">
//                       <label className="form-label">Includes</label>
//                       <Select
//                         isMulti
//                         options={[
//                           { value: "food", label: "Food" },
//                           { value: "hotel", label: "Hotel" },
//                           { value: "flight", label: "Flight" },
//                         ]}
//                         value={
//                           values.includes && typeof values.includes === "string"
//                             ? values.includes.split(", ").map((item) => ({
//                                 value: item,
//                                 label:
//                                   item.charAt(0).toUpperCase() + item.slice(1),
//                               }))
//                             : []
//                         }
//                         onChange={(selectedOptions) => {
//                           setValues({
//                             ...values,
//                             includes: selectedOptions
//                               .map((option) => option.value)
//                               .join(", "),
//                           });
//                         }}
//                         className={
//                           "react-select-container" +
//                           (errors.includes === false ? " is-invalid" : "")
//                         }
//                         classNamePrefix="react-select"
//                         placeholder={
//                           values.includes
//                             ? values.includes
//                                 .split(", ")
//                                 .map(
//                                   (item) =>
//                                     item.charAt(0).toUpperCase() + item.slice(1)
//                                 )
//                                 .join(", ")
//                             : "Select options..."
//                         }
//                         closeMenuOnSelect={false}
//                         hideSelectedOptions={false}
//                         controlShouldRenderValue={false}
//                         components={{
//                           Option: ({
//                             children,
//                             isSelected,
//                             innerProps,
//                             innerRef,
//                           }) => (
//                             <div
//                               ref={innerRef}
//                               {...innerProps}
//                               className={`d-flex align-items-center p-2 ${
//                                 isSelected ? "bg-light" : ""
//                               }`}
//                               style={{ cursor: "pointer" }}
//                             >
//                               <input
//                                 type="checkbox"
//                                 checked={isSelected}
//                                 readOnly
//                                 className="form-check-input me-2"
//                                 style={{ cursor: "pointer" }}
//                               />
//                               <label
//                                 style={{ cursor: "pointer", marginBottom: 0 }}
//                               >
//                                 {children}
//                               </label>
//                             </div>
//                           ),
//                           IndicatorSeparator: () => null,
//                         }}
//                         styles={{
//                           control: (base) => ({
//                             ...base,
//                             minHeight: "44px",
//                             borderColor:
//                               errors.includes === false ? "#dc3545" : "#ced4da",
//                             "&:hover": {
//                               borderColor:
//                                 errors.includes === false
//                                   ? "#dc3545"
//                                   : "#adb5bd",
//                             },
//                           }),
//                           placeholder: (base) => ({
//                             ...base,
//                             color: "#6c757d",
//                             whiteSpace: "nowrap",
//                             overflow: "hidden",
//                             textOverflow: "ellipsis",
//                           }),
//                           menu: (base) => ({
//                             ...base,
//                             marginTop: "4px",
//                             boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
//                             border: "1px solid #dee2e6",
//                           }),
//                           option: (base) => ({
//                             ...base,
//                             padding: 0,
//                             backgroundColor: "transparent",
//                             ":active": {
//                               backgroundColor: "#e9ecef",
//                             },
//                           }),
//                           dropdownIndicator: (base) => ({
//                             ...base,
//                             color: "6c757d",
//                             ":hover": {
//                               color: "#495057",
//                             },
//                           }),
//                           clearIndicator: (base) => ({
//                             ...base,
//                             color: "#6c757d",
//                             ":hover": {
//                               color: "#495057",
//                             },
//                           }),
//                         }}
//                       />
//                       {errors.includes === false && (
//                         <div className="invalid-feedback d-block">
//                           Please select at least one option
//                         </div>
//                       )}
//                     </div>
//                   </div>
//                   <div className="col-lg-4">
//                     <div className="mb-3">
//                       <label className="form-label">Price</label>
//                       <input
//                         type="text"
//                         name="price"
//                         value={values.price}
//                         onChange={handleInputChange}
//                         className={"form-control " + applyErrorClass("price")}
//                         placeholder="10000"
//                       />
//                       {errors.price === false && (
//                         <div className="validationerror">
//                           Please enter price
//                         </div>
//                       )}
//                     </div>
//                   </div>

//                   <div className="col-lg-4">
//                     <div className="mb-3">
//                       <label className="form-label">Currency</label>
//                       <select
//                         name="currency"
//                         value={values.currency}
//                         onChange={handleInputChange}
//                         className={"form-select " + applyErrorClass("currency")}
//                       >
//                         <option value="">Select Currency</option>
//                         {currencies.map((currency) => (
//                           <option key={currency.code} value={currency.code}>
//                             {currency.code}
//                           </option>
//                         ))}
//                       </select>
//                       {errors.currency === false && (
//                         <div className="validationerror">
//                           Please select a currency
//                         </div>
//                       )}
//                     </div>
//                   </div>
//                   <div className="col-lg-4">
//                     <div className="mb-3">
//                       <label className="form-label">Status</label>
//                       <select
//                         name="status"
//                         value={values.status}
//                         onChange={handleInputChange}
//                         className={"form-select " + applyErrorClass("status")}
//                       >
//                         <option value="">Select Status</option>
//                         <option value="Active">Active</option>
//                         <option value="Inactive">InActive</option>
//                       </select>
//                       {errors.status === false && (
//                         <div className="validationerror">
//                           Please select a status
//                         </div>
//                       )}
//                     </div>
//                   </div>
//                   <div className="col-lg-6">
//                     <div className="mb-3">
//                       <label htmlFor="packageDateId" className="form-label">
//                         Package Dates
//                       </label>
//                       <div className="input-group">
//                         <select
//                           name="packageDateId"
//                           value={values.packageDateId}
//                           onChange={handleInputChange}
//                           className={
//                             "form-select" + applyErrorClass("packageDateId")
//                           }
//                         >
//                           <option value="">Please select a date range</option>
//                           {packageDates.length > 0 &&
//                             packageDates.map((pd) => (
//                               <option
//                                 key={pd.packageDateId}
//                                 value={pd.packageDateId}
//                               >
//                                 {moment(pd.startDate).format("DD MMM YYYY")} -{" "}
//                                 {moment(pd.endDate).format("DD MMM YYYY")}
//                               </option>
//                             ))}
//                         </select>
//                         <button
//                           type="button"
//                           className="btn btn-primary"
//                           onClick={() => setShowPackageDateModal(true)}
//                         >
//                           +
//                         </button>
//                       </div>
//                       {errors.packageDateId === false && (
//                         <div className="validationerror">
//                           Please select a date range
//                         </div>
//                       )}
//                     </div>
//                   </div>
//                   <div className="col-12">
//                     <div className="mb-3">
//                       <label className="form-label">Description</label>
//                       <textarea
//                         name="description"
//                         value={values.description}
//                         onChange={handleInputChange}
//                         className={
//                           "form-control " + applyErrorClass("description")
//                         }
//                         placeholder="Enter Description"
//                         rows="3"
//                       ></textarea>
//                       {errors.description === false && (
//                         <div className="validationerror">
//                           Please enter description
//                         </div>
//                       )}
//                     </div>
//                   </div>
//                 </div>

//                 <div className="row bg-warning pt-1">
//                   <div className="col-lg-4">
//                     <div className="mb-3">
//                       <label className="form-label">Contact Name</label>
//                       <input
//                         type="text"
//                         name="contactName"
//                         value={values.contactName}
//                         onChange={handleInputChange}
//                         className={
//                           "form-control " + applyErrorClass("contactName")
//                         }
//                         placeholder="e.g Rajesh"
//                       />
//                       {errors.contactName === false && (
//                         <div className="validationerror">
//                           Please enter contact name
//                         </div>
//                       )}
//                     </div>
//                   </div>
//                   <div className="col-lg-4">
//                     <div className="mb-3">
//                       <label className="form-label">Contact Phone</label>
//                       <input
//                         type="tel"
//                         maxLength={15}
//                         name="contactPhoneNumber"
//                         value={values.contactPhoneNumber}
//                         onChange={handleInputChange}
//                         className={
//                           "form-control " +
//                           applyErrorClass("contactPhoneNumber")
//                         }
//                         placeholder="e.g 9999999999"
//                       />
//                       {errors.contactPhoneNumber === false && (
//                         <div className="validationerror">
//                           Please enter contact phone number
//                         </div>
//                       )}
//                     </div>
//                   </div>
//                   <div className="col-lg-4">
//                     <div className="mb-3">
//                       <label className="form-label">Contact Email</label>
//                       <input
//                         type="text"
//                         maxLength={40}
//                         name="contactEmail"
//                         value={values.contactEmail}
//                         onChange={handleInputChange}
//                         className={
//                           "form-control " + applyErrorClass("contactEmail")
//                         }
//                         placeholder="e.g rajesh@gmail.com"
//                       />
//                       {errors.contactEmail === false && (
//                         <div className="validationerror">
//                           Please enter contact email
//                         </div>
//                       )}
//                     </div>
//                   </div>
//                 </div>

//                 <div className="col-lg-12">
//                   <div className="hstack gap-2 justify-content-end mb-3 mt-4">
//                     {!btnLoading ? (
//                       <button type="submit" className="btn btn-primary">
//                         {isEditMode ? "Edit Package" : "Add Package"}
//                       </button>
//                     ) : (
//                       <button
//                         type="submit"
//                         className="btn btn-primary"
//                         disabled
//                       >
//                         Please wait...
//                       </button>
//                     )}
//                     <button
//                       type="button"
//                       className="btn btn-danger"
//                       onClick={resetForm}
//                     >
//                       Cancel
//                     </button>
//                   </div>
//                 </div>
//               </form>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default HajjPackageForm;

import React, { useState, useEffect, useRef, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import config from "../../Common/Configurations/APIConfig";
import apiService from "../../Common/Configurations/APIService";
import { useAuth } from "../../Common/Configurations/AuthContext";
import moment from "moment";
import Flatpickr from "react-flatpickr";
import Select from "react-select";
import currencies from "../../Data/Currency.json";
import citiesData from '../../Data/popular_cities_100_countries.json';

// Component-specific Modals
import PackageDateModal from "../Package/PackageDateModal";
import FromOriginModal from "../Package/FromOriginModal";
import ImageUploadModal from "../Package/ImageUploadModal";
import ImageViewModal from "../Package/ImageViewModal";

// Import the CSS from PackageForm for consistent styling
import '../Package/PackageForm.css';

const DEFAULT_IMAGE = "/assets/images/umrah.jpg"; // Using a specific default image for Hajj

const initialFieldValues = {
  packageId: "00000000-0000-0000-0000-000000000000",
  destination: "Saudi Arabia",
  travelType: "GROUP",
  companyId: "00000000-0000-0000-0000-000000000000",
  userId: "00000000-0000-0000-0000-000000000000",
  fromOriginId: "",
  packageDateId: "",
  imageName: "",
  imageFile: null,
  imageSrc: DEFAULT_IMAGE,
  packageName: "Hajj Package",
  noOfPersons: "1",
  startedDate: moment().format("DD-MMM-YYYY"),
  duration: "30 Nights / 31 Days",
  includes: "flight, hotel, food, visa",
  description: "",
  destinationsCover: "Makkah, Madinah, Mina, Arafat",
  price: "",
  status: "Active",
  type: "Hajj", // <-- Important: Type is set to Hajj
  contactName: "",
  contactPhoneNumber: "",
  contactEmail: "",
  currency: "",
};

const HajjPackageForm = ({
  packageId,
  isEditMode,
  setIsEditMode,
  onPackageCreated,
  packageDetails
}) => {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const [btnLoading, setBtnLoading] = useState(false);
  const [values, setValues] = useState(initialFieldValues);
  const [errors, setErrors] = useState({});
  const [origin, setOrigin] = useState([]);
  const [imagePreview, setImagePreview] = useState(DEFAULT_IMAGE);
  const [showImageUploadModal, setShowImageUploadModal] = useState(false);
  const [showImageViewModal, setShowImageViewModal] = useState(false);
  const flatpickrRef = useRef(null);
  const [packageDates, setPackageDates] = useState([]);
  const [showPackageDateModal, setShowPackageDateModal] = useState(false);
  const [showFromOriginModal, setShowFromOriginModal] = useState(false);
  const [suggestions, setSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [showAdvanced, setShowAdvanced] = useState(false);

  useEffect(() => {
    if (packageDetails) {
      setValues({
        ...initialFieldValues,
        ...packageDetails,
        startedDate: moment(packageDetails.startedDate).format("DD-MMM-YYYY"),
      });
      setImagePreview(packageDetails.imageSrc || DEFAULT_IMAGE);
      setIsEditMode(true);
    } else if (user && !loading && !packageId) {
      setValues((prev) => ({
        ...initialFieldValues,
        contactName: user.name || "",
        contactPhoneNumber: user.phoneNumber || "",
        contactEmail: user.email || "",
        currency: user.currency || "INR",
        imageSrc: DEFAULT_IMAGE,
      }));
    }
  }, [packageDetails, user, loading, packageId, setIsEditMode]);

  const GetPackageDates = async (packageType) => {
    if (!user?.cid) return;
    try {
      const url = `${config.GETDATESBYTYPE}/${user.cid}?type=${packageType}`;
      const res = await apiService.getAll(url);
      setPackageDates(res);
    } catch (error) {
      console.error("Error fetching package dates:", error);
      setPackageDates([]);
    }
  };

  const GetOrigins = async () => {
    if (!user?.cid) return;
    try {
      const res = await apiService.get(`${config.GETALLORIGINBYCOMPANYID}/${user?.cid}`);
      setOrigin(res);
    } catch (error) {
      console.error("Error fetching origins:", error);
      setOrigin([]);
    }
  };

  const handlePackageDateCreated = () => GetPackageDates("Hajj");
  const handleOriginCreated = () => GetOrigins();

  useEffect(() => {
    if (user) {
      GetOrigins();
      GetPackageDates("Hajj");
    }
  }, [user]);

  const validate = () => {
    let temp = {};
    temp.destination = values.destination !== "";
    temp.packageName = values.packageName !== "";
    temp.duration = values.duration !== "";
    temp.startedDate = values.startedDate !== "";
    temp.noOfPersons = values.noOfPersons !== "" && values.noOfPersons > 0;
    temp.price = values.price !== "" && !isNaN(values.price);
    temp.currency = values.currency !== "";
    temp.description = values.description !== "";
    temp.imageFile = isEditMode ? true : values.imageFile !== null;
    temp.status = values.status !== "";
    setErrors(temp);
    return Object.values(temp).every((x) => x === true);
  };

  const handleImageUpload = (file, imageSrc) => {
    setImagePreview(imageSrc);
    setValues({
      ...values,
      imageFile: file,
      imageSrc: imageSrc,
      imageName: file ? file.name : "default-hajj.jpg",
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validate()) {
      setBtnLoading(true);
      const formData = new FormData();
      Object.entries({ ...values, companyId: user?.cid, userId: user?.id })
        .forEach(([key, value]) => {
          formData.append(key, value ?? "");
        });

      if (values.imageFile) {
        formData.append("imageFile", values.imageFile);
      }

      try {
        if (isEditMode) {
          await apiService.update(config.UPDATEPACKAGE, formData);
        } else {
          const response = await apiService.create(config.CREATEPACKAGE, formData);
          if (response && response.packageId) {
            onPackageCreated(response.packageId);
          }
        }
      } catch (error) {
        console.error("Error submitting form:", error);
      } finally {
        setBtnLoading(false);
      }
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setValues({ ...values, [name]: value });
  };

  const handlePersonChange = (amount) => {
    setValues((prev) => {
      const currentPersons = parseInt(prev.noOfPersons, 10) || 0;
      const newPersons = Math.max(1, currentPersons + amount);
      return { ...prev, noOfPersons: newPersons.toString() };
    });
  };

  const allCities = useMemo(() => {
    const cityList = [];
    for (const country in citiesData) {
      if (citiesData.hasOwnProperty(country)) {
        cityList.push(country);
        citiesData[country].forEach(city => cityList.push(`${city}-${country}`));
      }
    }
    return cityList;
  }, []);

  const handleDestinationChange = (e) => {
    const userInput = e.target.value;
    setValues({ ...values, destination: userInput });
    if (userInput) {
      const filtered = allCities.filter(s => s.toLowerCase().includes(userInput.toLowerCase()));
      setSuggestions(filtered);
      setShowSuggestions(true);
    } else {
      setSuggestions([]);
      setShowSuggestions(false);
    }
  };

  const handleSuggestionClick = (suggestion) => {
    setValues({ ...values, destination: suggestion });
    setSuggestions([]);
    setShowSuggestions(false);
  };

  const resetForm = () => {
    const contactInfo = {
      contactName: user.name || "",
      contactPhoneNumber: user.phoneNumber || "",
      contactEmail: user.email || "",
      currency: user.currency || "INR",
    };
    setValues({ ...initialFieldValues, ...contactInfo });
    setImagePreview(DEFAULT_IMAGE);
    setBtnLoading(false);
    setErrors({});
  };

  const applyErrorClass = (field) => field in errors && errors[field] === false ? " form-control-danger" : "";

  return (
    <div className="PackageForm-wrapper">
      <PackageDateModal show={showPackageDateModal} onHide={() => setShowPackageDateModal(false)} onPackageDateCreated={handlePackageDateCreated} type="Hajj" />
      <FromOriginModal show={showFromOriginModal} onHide={() => setShowFromOriginModal(false)} onOriginCreated={handleOriginCreated} />
      <ImageUploadModal show={showImageUploadModal} onHide={() => setShowImageUploadModal(false)} onImageUpload={handleImageUpload} title="Upload Hajj Package Image" defaultImage={DEFAULT_IMAGE} aspectRatio="4/3" />
      <ImageViewModal show={showImageViewModal} onHide={() => setShowImageViewModal(false)} imageSrc={imagePreview} title="Hajj Package Image" defaultImage={DEFAULT_IMAGE} aspectRatio="4/3" />

      <div className="PackageForm-header d-flex justify-content-between align-items-center mb-4">
        <h5 className="mb-0">{isEditMode ? "Edit Hajj Package" : "Create a New Hajj Package"}</h5>
      </div>

      <form onSubmit={handleSubmit} autoComplete="off" noValidate>
        <div className="card PackageForm-section-card">
          <div className="card-body">
            <div className="row">
              <div className="col-lg-8">
                <div className="row">
                  

                  <div className="col-md-4 mb-3">
                    <label className="PackageForm-label form-label d-flex align-items-center"><i className="ri-flight-takeoff-line me-2"></i>Origin</label>
                    <div className="input-group">
                      <select name="fromOriginId" value={values.fromOriginId} onChange={handleInputChange} className={"form-select" + applyErrorClass("fromOriginId")}>
                        <option value="">Please select</option>
                        {origin.map((o) => (<option key={o.fromOriginId} value={o.fromOriginId}>{o.fromOriginName}</option>))}
                      </select>
                      <button type="button" className="btn btn-outline-secondary" onClick={() => setShowFromOriginModal(true)}>+</button>
                    </div>
                  </div>

                  <div className="col-md-4 mb-3 Destinationautocomplete-container">
                    <label className="PackageForm-label form-label d-flex align-items-center"><i className="ri-map-pin-line me-2"></i>Destination</label>
                    <input type="text" name="destination" value={values.destination} onChange={handleDestinationChange} className={"form-control" + applyErrorClass("destination")} placeholder="e.g., Saudi Arabia" autoComplete="off" onBlur={() => setTimeout(() => setShowSuggestions(false), 200)} />
                    {showSuggestions && suggestions.length > 0 && (
                      <ul className="Destinationautocomplete-suggestions-list">
                        {suggestions.slice(0, 10).map((suggestion, index) => (<li key={index} className="Destinationautocomplete-suggestion-item" onMouseDown={() => handleSuggestionClick(suggestion)}>{suggestion}</li>))}
                      </ul>
                    )}
                    {errors.destination === false && <div className="validationerror">Please enter a destination</div>}
                  </div>

                  <div className="col-md-4 mb-3">
                    <label className="PackageForm-label form-label d-flex align-items-center"><i className="ri-suitcase-line me-2"></i>Travel Type</label>
                    <select name="travelType" value={values.travelType} onChange={handleInputChange} className={"form-select" + applyErrorClass("travelType")}>
                      <option value="">Select Travel Type</option>
                      <option value="FAMILY">Family</option>
                      <option value="GROUP">Group</option>
                    </select>
                  </div>
                  <div className="col-12 mb-3">
                    <label className="PackageForm-label form-label d-flex align-items-center"><i className="ri-medal-line me-2"></i>Package Name</label>
                    <input type="text" name="packageName" value={values.packageName} onChange={handleInputChange} className={"form-control form-control-md" + applyErrorClass("packageName")} placeholder="e.g. 30 Days Premium Hajj Package" />
                    {errors.packageName === false && <div className="validationerror">Please enter package name</div>}
                  </div>
                </div>
              </div>

              <div className="col-lg-4">
                <div className={`PackageForm-image-upload-box text-center p-1 border rounded ${errors.imageFile === false && !isEditMode ? 'border-danger' : ''}`}>
                  <img src={imagePreview} alt="Package Preview" className="img-fluid rounded mb-3" style={{ maxHeight: "150px" }} />
                  <div className="d-flex gap-2 justify-content-center">
                    <button type="button" className="btn btn-sm btn-primary" onClick={() => setShowImageUploadModal(true)}><i className="ri-upload-2-line me-1"></i> Upload</button>
                    <button type="button" className="btn btn-sm btn-outline-secondary" onClick={() => setShowImageViewModal(true)}><i className="ri-eye-line me-1"></i> View</button>
                  </div>
                  {errors.imageFile === false && !isEditMode && <div className="validationerror mt-2">Please upload an image</div>}
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-3 mb-3">
                <label className="PackageForm-label form-label d-flex align-items-center"><i className="ri-time-line me-2"></i>Duration</label>
                <select name="duration" value={values.duration} onChange={handleInputChange} className={"form-select " + applyErrorClass("duration")}>
                  <option value="">Select Duration</option>
                  {Array.from({ length: 45 }, (_, i) => { const n = i + 1; const d = n + 1; return <option key={n} value={`${n} Nights / ${d} Days`}>{`${n} Night${n > 1 ? "s" : ""} / ${d} Day${d > 1 ? "s" : ""}`}</option>; })}
                </select>
                {errors.duration === false && <div className="validationerror">Please select</div>}
              </div>
              <div className="col-md-3 mb-3">
                <label className="PackageForm-label form-label d-flex align-items-center"><i className="ri-calendar-event-line me-2"></i>Travel Date</label>
                <div className="input-group">
                  <Flatpickr className={"form-control" + applyErrorClass("startedDate")} name="startedDate" options={{ dateFormat: "d-M-Y", clickOpens: false }} value={values.startedDate} onChange={(date) => { handleInputChange({ target: { name: "startedDate", value: moment(date[0]).format("DD-MMM-YYYY") } }); }} ref={flatpickrRef} readOnly />
                  <div className="input-group-text bg-primary border-primary text-white" style={{ cursor: "pointer" }} onClick={() => flatpickrRef.current.flatpickr.open()}><i className="ri-calendar-2-line" /></div>
                </div>
              </div>
              <div className="col-md-2 mb-3">
                <label className="PackageForm-label form-label d-flex align-items-center"><i className="ri-group-line me-2"></i>No of Persons</label>
                <div className="input-group">
                  <button className="btn btn-outline-secondary" type="button" onClick={() => handlePersonChange(-1)}>-</button>
                  <input type="number" name="noOfPersons" value={values.noOfPersons} onChange={handleInputChange} className={"form-control text-center" + applyErrorClass("noOfPersons")} min="1" />
                  <button className="btn btn-outline-secondary" type="button" onClick={() => handlePersonChange(1)}>+</button>
                </div>
              </div>
              <div className="col-md-4 mb-3">
                <label className="PackageForm-label form-label d-flex align-items-center"><i className="ri-money-dollar-circle-line me-2"></i>Price Per Person</label>
                <div className="input-group">
                  <select name="currency" value={values.currency} onChange={handleInputChange} className={"input-group-text" + applyErrorClass("currency")}>
                    {currencies.map((c) => <option key={c.code} value={c.code}>{c.code}</option>)}
                  </select>
                  <input type="number" name="price" value={values.price} onChange={handleInputChange} className={"form-control " + applyErrorClass("price")} placeholder="500000" min="1" />
                </div>
                {errors.price === false && <div className="validationerror">Please enter a valid price</div>}
              </div>
              <div className="col-12 mb-3">
                <label className="PackageForm-label form-label d-flex align-items-center"><i className="ri-file-text-line me-2"></i>Description</label>
                <textarea name="description" value={values.description} onChange={handleInputChange} className={"form-control " + applyErrorClass("description")} placeholder="Give a captivating description of the Hajj package..." rows="4"></textarea>
                {errors.description === false && <div className="validationerror">Please enter description</div>}
              </div>
            </div>

            <div className="col-12 text-center my-3">
              <button type="button" className="btn btn-primary" onClick={() => setShowAdvanced(!showAdvanced)}>
                {showAdvanced ? "Hide" : "Show"} Advanced Options <i className={`ri-arrow-${showAdvanced ? "up" : "down"}-s-line align-middle`}></i>
              </button>
            </div>
          </div>
        </div>

        {showAdvanced && (
          <div className="card PackageForm-section-card" style={{ backgroundColor: "#e9f5ff" }}>
            <div className="card-body">
              <h5 className="section-title">Advanced Details</h5>
              <div className="row">
                <div className="col-lg-6 mb-3">
                  <label className="form-label d-flex align-items-center"><i className="ri-road-map-line me-2"></i>Destinations Cover</label>
                  <input type="text" name="destinationsCover" value={values.destinationsCover} onChange={handleInputChange} className={"form-control " + applyErrorClass("destinationsCover")} placeholder="e.g. Makkah, Madinah, Mina, Arafat"/>
                </div>
                <div className="col-lg-6 mb-3">
                  <label className="form-label d-flex align-items-center"><i className="ri-check-double-line me-2"></i>Includes</label>
                  <Select isMulti options={[{ value: "food", label: "Food" }, { value: "hotel", label: "Hotel" }, { value: "flight", label: "Flight" }, { value: "visa", label: "Visa" }, { value: "transport", label: "Transport" }]} value={values.includes ? values.includes.split(", ").map(item => ({ value: item, label: item.charAt(0).toUpperCase() + item.slice(1) })) : []} onChange={(opts) => setValues({ ...values, includes: opts.map(o => o.value).join(", ") })} className={"react-select-container"} classNamePrefix="react-select"/>
                </div>
                <div className="col-lg-6 mb-3">
                  <label className="form-label d-flex align-items-center"><i className="ri-calendar-2-line me-2"></i>Package Dates</label>
                  <div className="input-group">
                    <select name="packageDateId" value={values.packageDateId} onChange={handleInputChange} className={"form-select"}>
                      <option value="">Please select a date range</option>
                      {packageDates.map((pd) => (<option key={pd.packageDateId} value={pd.packageDateId}>{`${moment(pd.startDate).format("DD MMM YYYY")} - ${moment(pd.endDate).format("DD MMM YYYY")}`}</option>))}
                    </select>
                    <button type="button" className="btn btn-outline-secondary" onClick={() => setShowPackageDateModal(true)}>+</button>
                  </div>
                </div>
                <div className="col-lg-6 mb-3">
                  <label className="form-label d-flex align-items-center"><i className="ri-toggle-line me-2"></i>Status</label>
                  <select name="status" value={values.status} onChange={handleInputChange} className={"form-select"}>
                    <option value="Active">Active</option>
                    <option value="Inactive">Inactive</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        )}

        <div className="card PackageForm-section-card" style={{ backgroundColor: "#d4edda" }}>
          <div className="card-body">
            <h5 className="section-title">Contact Information</h5>
            <div className="row">
              <div className="col-lg-4 mb-3">
                <label className="form-label d-flex align-items-center"><i className="ri-user-line me-2"></i>Contact Name</label>
                <input type="text" name="contactName" value={values.contactName} onChange={handleInputChange} className="form-control" />
              </div>
              <div className="col-lg-4 mb-3">
                <label className="form-label d-flex align-items-center"><i className="ri-phone-line me-2"></i>Contact Phone</label>
                <input type="tel" maxLength={15} name="contactPhoneNumber" value={values.contactPhoneNumber} onChange={handleInputChange} className="form-control" />
              </div>
              <div className="col-lg-4 mb-3">
                <label className="form-label d-flex align-items-center"><i className="ri-mail-line me-2"></i>Contact Email</label>
                <input type="text" maxLength={40} name="contactEmail" value={values.contactEmail} onChange={handleInputChange} className="form-control" />
              </div>
            </div>
          </div>
        </div>

        <div className="PackageForm-actions-footer">
          <div className="hstack gap-2 justify-content-end">
            <button type="button" className="btn btn-light" onClick={resetForm}>Cancel</button>
            <button type="submit" className="btn btn-primary" disabled={btnLoading}>
              {btnLoading ? "Saving..." : isEditMode ? "Update Hajj Package" : "Create Hajj Package"}
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default HajjPackageForm;